import video1 from "../assets/video1.mp4"
import video2 from "../assets/video2.mp4"
import video3 from "../assets/video3.mp4"

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/effect-fade";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const Carousel = () => {
    const videos=[video1, video2, video3]
    const [captions, setCaptions] = useState([
        { title: "", subtitle: "" },
        { title: "", subtitle: "" },
        { title: "", subtitle: "" },
    ]);

    useEffect(() => {
        const fetchAdverts = async () => {
            try {
                const advertsCol = collection(db, "adverts");
                const advertSnapshot = await getDocs(advertsCol);
                const advertData = advertSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                const newCaptions = [
                    { title: "", subtitle: "" },
                    { title: "", subtitle: "" },
                    { title: "", subtitle: "" },
                ];
                
                advertData.forEach((advert) => {
                    const title = advert.advertTitle || "";
                    const subtitle = advert.advertDesc || "";
                    if (advert.id === 'advert1') newCaptions[0] = { title, subtitle };
                    if (advert.id === 'advert2') newCaptions[1] = { title, subtitle };
                    if (advert.id === 'advert3') newCaptions[2] = { title, subtitle };
                });
                
                setCaptions(newCaptions);
            } catch (error) {
                console.error("Error fetching adverts: ", error);
            }
        };

        fetchAdverts();
    }, []);

    return (
        <div className="carousel">
            <Swiper
                modules={[Pagination,
                    Autoplay, EffectFade]}
                effect="fade"
                fadeEffect={{ crossFade: true }}
                spaceBetween={0}
                slidesPerView={1}
                pagination={{
                    clickable: true,
                    renderBullet: function (index, className) {
                        return `<span class="${className} swiper-pagination-bullet-custom">
                                    <video class="thumb-video" src="${videos[index]}#t=0.1" muted playsinline></video>
                                </span>`;
                    },
                }}
                navigation
                autoplay={{ delay: 4000 }}
            >
                {videos.map((video, index) => (
                    <SwiperSlide key={index}>
                        <div className="carousel-slide">
                            <video
                                src={video}
                                className="carousel-video"
                                autoPlay
                                loop
                                muted
                                playsInline
                            />
                            <div className="carousel-caption">
                                <h2 className="carousel-caption__title">{captions[index]?.title}</h2>
                                <p className="carousel-caption__subtitle">{captions[index]?.subtitle}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};
